const router = [
  {
    path: "/order/tuanGouOrderDetail/:arg",
    name: "orderTuanGouOrderDetail",
    component: () => import("@/views/order/tuanGouOrderDetail.vue"),
    meta: {
      keepAlive: false,
    },
  },
];

export default router;
